import { Header, withLayout } from '@/components';
import { CompanyTerms } from '@/components/company/CompanyTerms';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';

const Page: NextPage = () => {
  return withLayout(
    <>
      <NextSeo title="利用規約" />
      <Header />
      <CompanyTerms />
    </>,
  );
};

export default Page;
